// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"a193296f","703":"50190ea6","787":"949140e7"}[chunkId] + ".chunk.js";
};